import { createAction } from 'redux-actions';
import * as types from './types';

import { logout } from 'modules/auth/actions';


export const toggleMessage = createAction(types.TOGGLE_MESSAGE);
export const toggleCollapse = createAction(types.TOGGLE_COLLAPSE);
export const setCurrentHomeView = createAction(types.SET_CURRENT_HOME_VIEW);
export const setGlobalBasket = createAction(types.SET_GLOBAL_BASKET);
export const setQuotationBasket = createAction(types.SET_QUOTATION_BASKET);
export const setGlobalPaymentData = createAction(types.SET_GLOBAL_PAYMENT_DATA);
export const setGlobalSelectedMount = createAction(types.SET_GLOBAL_SELECTED_MOUNT);
export const toggleModalEffectCreation = createAction(types.TOGGLE_MODAL_EFFECT_CREATION);
export const setMountQuotations = createAction(types.SET_MOUNT_QUOTATIONS);

export const setUp = () => {
  return async (dispatch, getState) => {
  }
};

export const setUpAdmin = () => {
  return async (dispatch, getState) => {

  }
}

export const resetEnv = () => {
  return async (dispatch, getState) => {
    dispatch(resetUiEnv())
    dispatch(logout());
  }
}

export const toggleGlobalLoader = createAction(types.TOGGLE_GLOBAL_LOADER)
export const resetUiEnv = createAction(types.RESET_UI_ENV);
export const setTheme = createAction(types.SET_THEME);